import {
  PriorAuthGateOutcomeT,
  type MedicationDecisionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

export function medicationDecisionActions(
  outcome: PriorAuthGateOutcomeT | null,
  canStartExcludedPriorAuth: boolean
): MedicationDecisionT[] {
  switch (outcome) {
    case PriorAuthGateOutcomeT.NO_PA:
      return ['SEND_NO_PA'];
    case PriorAuthGateOutcomeT.PA_REQUIRED:
      return ['START_PA', 'SELF_PAY'];
    case PriorAuthGateOutcomeT.EXCLUDED:
      return canStartExcludedPriorAuth ? ['START_PA', 'SELF_PAY'] : ['SELF_PAY'];
    case PriorAuthGateOutcomeT.NO_COVERAGE:
      return ['SELF_PAY'];
    case PriorAuthGateOutcomeT.UNKNOWN:
      return ['EXCEPTIONAL_UNKNOWN_SEND'];
    default:
      return [];
  }
}

export function requiresDiagnosisForInsuranceApproval(
  formularyRequiresInsuranceApproval: boolean,
  decisionActions: readonly MedicationDecisionT[]
): boolean {
  return formularyRequiresInsuranceApproval || decisionActions.includes('START_PA');
}

/**
 * A positive formulary PA restriction is already sufficient to offer the
 * prior-authorization path. The slower patient-specific benefits preview can
 * add cost and pharmacy details, but cannot downgrade that restriction.
 */
export function resolveMedicationDecisionOutcome(
  previewOutcome: PriorAuthGateOutcomeT | null,
  formularyRequiresPriorAuth: boolean
): PriorAuthGateOutcomeT | null {
  return formularyRequiresPriorAuth ? PriorAuthGateOutcomeT.PA_REQUIRED : previewOutcome;
}
